import { instance } from "api/apiBase";
import api from "api/landlord/address";
import { Additional } from "./templates";

export const loadUnitOptions = async (
  search: string,
  _,
  {
    page,
    propertyId
  }: {
    page: number;
    propertyId: number;
  }
) => {
  if (!propertyId) return { options: [], hasMore: false };

  const data = await api.getUnitsOfProperty({
    propertyId,
    searchTerm: search || "",
    page
  });

  return {
    options: data?.items?.map((item) => ({
      value: item.id,
      label: item.title,
      isDisabled: !item.magic_link?.active,
      tooltip: !item.magic_link?.active
        ? `You can invite applicants to a unit/site that accepts applications`
        : undefined
    })),
    hasMore: data.has_more,
    additional: {
      page: page + 1,
      propertyId
    }
  };
};

export const loadBoomReportUnitOptions = async (
  search: string,
  _: unknown,
  additional: Additional
) => {
  const { page, propertyId } = additional;
  if (!propertyId) return { options: [], hasMore: false };

  const data = await api.getUnitsOfProperty({
    propertyId,
    searchTerm: search || "",
    page
  });

  return {
    options: data?.items?.map((item) => ({
      value: item.id,
      label: item.title
    })),
    hasMore: data.has_more,
    additional: {
      page: page + 1,
      propertyId
    }
  };
};

export const loadPropertyOptions = async (search: string, _, { page }) => {
  const data = await api.getProperties({
    searchTerm: search,
    page
  });

  return {
    options: data?.items?.map((item) => ({
      value: item.id,
      label: item.name || item?.address?.address1 || ""
    })),
    hasMore: data.has_more,
    additional: {
      page: page + 1
    }
  };
};

export const loadPropertyGroupOptions = async (search: string) => {
  const data = await instance
    .get(`/portal/v1/property_groups`, {
      params: {
        search: search
      }
    })
    .then((res) => res.data);

  return {
    options:
      data?.property_groups?.map((item) => ({
        value: item.id,
        label: item.name
      })) || [],
    hasMore: false,
    additional: {}
  };
};
